import { MapContainer, TileLayer} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from '@iconify/react';
import MapApiPinpoint from './child/MapApiPinpoint'; 

// Fix default icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


const TehsilMapView = ({ plantations, onBack }) => {
  if (!plantations || !plantations.length) return <p>No plantation data</p>;

  const bounds = plantations.map(p => [p.coordinates[1], p.coordinates[0]]);

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <button onClick={onBack} className="btn btn-secondary btn-sm">
          <Icon icon="mdi:arrow-left" className="me-1" /> Back to Tehsils
        </button>
        <h5 className="mb-0">Plantation Map</h5>
        <div />
      </div>
      <div className="card-body p-0">
        <MapContainer
          style={{ height: '900px', width: '100%' }}
          bounds={bounds}
          scrollWheelZoom
          zoom={10}
        >
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            attribution='Tiles &copy; Esri'
          />
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
            attribution='Tiles &copy; Esri'
          />

          {plantations.map((p, idx) => {
            // ✅ MapApiPinpoint expects full plantation object
            const plantation = {
              _id: p._id,
              plantationKey: p.plantationKey || 'N/A',
              location: {
                type: 'Point',
                coordinates: p.coordinates,
              },
              category: p.category || 'DEPARTMENTAL',
              province: p.province || 'N/A',
              district: p.district || 'N/A',
              tehsil: p.tehsil || 'N/A',
              siteName: p.siteName || 'N/A',
              siteType: p.siteType || 'N/A',
              plantType: p.plantType || 'N/A',
              plantationType: p.plantationType || 'N/A',
              plantationCampaign: p.plantationCampaign || 'N/A',
              plantationProgram: p.plantationProgram || 'N/A',
              numberOfPlants: p.numberOfPlants || 0,
              speciesName: p.speciesName || [],
              plantationDate: p.plantationDate || null,
              images: p.images || [],
              followUps: p.followUps || [],
            };

            return <MapApiPinpoint key={idx} plantation={plantation} index={idx} />;
          })}
        </MapContainer>
      </div>
    </div>
  );
};

export default TehsilMapView;